// extracted by mini-css-extract-plugin
module.exports = {"barGraph":"dailyBarGraph_barGraph__7V0sl"};